import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { observer } from "mobx-react-lite";
import { useViewSettingsStore } from "../..";
import commonStyles from "../Common.module.css";

export default observer(() => {
    const viewSettingsStore = useViewSettingsStore();

    return viewSettingsStore.isPopupExpanded
        ? <ExpandLessIcon className={commonStyles.clickableIcon} onClick={() => viewSettingsStore.setIsPopupExpanded(false)} />
        : <ExpandMoreIcon className={commonStyles.clickableIcon} onClick={() => viewSettingsStore.setIsPopupExpanded(true)} />
});